<template>
  <div class="dashboard">
    <v-card-title>
      <v-alert
        :value="!!error"
        type="error"
        dismissible
      > There was an error. Please try again or reach out to Headway’s underwriting team
      </v-alert>
      <page-title :title="title"></page-title>
      <v-spacer></v-spacer>
    </v-card-title>
    <app-data-table
      :headers="headers"
      :items="accounts"
      @rowClick="onRowClick"
    ></app-data-table>
  </div>
</template>

<script>
import AppDataTable from '@/components/AppDataTable.vue';
import PageTitle from '@/components/PageTitle.vue';
import serializeAccount from '@/utils/serialize-account';
import { mapState } from 'vuex';

export default {
  name:       'Dashboard',
  components: {
    AppDataTable,
    PageTitle,
  },
  props: {
    query: {
      type:    String,
      default: '',
    },
  },
  data() {
    return {
      title:   'Account Search',
      headers: [
        {
          text:  'Business Name',
          value: 'businessName',
        },
        {
          text:  'Name',
          value: 'applicantName',
        },
        {
          text:  'Email',
          value: 'email',
        },
        {
          text:  'Phone Number',
          value: 'phoneNumber', // modified in @/utils/serialize-account
        },
      ],
    };
  },
  computed: {
    ...mapState('account', ['records', 'error']),
    accounts() {
      return this.records.map(serializeAccount);
    },
  },
  methods: {
    onRowClick(data) {
      this.$router.push({
        path: `/accounts/${data.row.id}`,
      });
    },

  },
  mounted() {
    this.$store.dispatch('account/searchAccounts', this.query);
  },

};
</script>
